import { queryClient } from '@/plugins/vue-query'

/**
 * Imperative "read it now" for forms that copy server data into local state when they open
 * (questionnaire-style add/edit pages). Always re-reads — the form must start from what is saved —
 * but goes through the query client, so concurrent reads share one request and failures surface
 * through the normal client error handling.
 *
 * @template T
 * @param {readonly unknown[]} queryKey
 * @param {() => Promise<T>} queryFn
 * @returns {Promise<T>}
 */
export function readFresh(queryKey, queryFn) {
  return queryClient.fetchQuery({ queryKey, queryFn, staleTime: 0 })
}
